import { ListChart, ListChartProps } from '../../../renderers/list-chart/list-chart.component';
import { IOTS_UPTIME_BY_TYPE_LIST_CHART_DEFINITION } from './iots-uptime-by-type-list-chart.definition';
import { IOTS_UPTIME_BY_TYPE_LIST_CHART_MOCK_DATA } from './iots-uptime-by-type-list-chart.mock';

export const IotsUptimeByTypeListChart = (props: ListChartProps) => <ListChart {...props} />;

IotsUptimeByTypeListChart.definition = IOTS_UPTIME_BY_TYPE_LIST_CHART_DEFINITION;
IotsUptimeByTypeListChart.mockData = IOTS_UPTIME_BY_TYPE_LIST_CHART_MOCK_DATA;
